import { css } from '@emotion/react';
import {
  type CSSProperties,
  type ReactNode, type Ref,
} from 'react';
import { zIndexGeneral } from '~/_shared/constants/zIndexGeneral.enum';
import { noop } from '../../utils/function.helpers';
import { useClickOutsideListenerRef } from '../../utils/hooks/useClickOutsideListenerRef';
import { useCombinedRefs } from '../../utils/hooks/useCombinedRefs';
import { contextMenuStyle } from '../dropdown';

const menuPositionStyle = () => css({
  position: 'absolute',
  zIndex: zIndexGeneral.ContextMenu,
});

const menuStyle = ({ maxWidth }: {maxWidth?: number}) => css({
  boxSizing: 'border-box',
  position: 'relative',
  width: 'auto',
  maxWidth,
});

type ContextMenuContentProps = Readonly<{
  children: ReactNode;
  className?: string;
  isVisible: boolean;
  style?: CSSProperties;
  ref?: Ref<HTMLDivElement>;
  maxWidth?: number;

  onHide?: () => void;
}>;

export const ContextMenuContentComponent = (props: ContextMenuContentProps) => {
  const innerRef = useClickOutsideListenerRef(props.onHide ?? noop, props.isVisible);
  const combinedRef = useCombinedRefs(props.ref, innerRef);

  if (!props.isVisible) {
    return null;
  }

  return (
    <div
      css={menuPositionStyle}
      ref={combinedRef}
      style={props.style}
    >
      <div
        css={[menuStyle({ maxWidth: props.maxWidth }), contextMenuStyle]}
        className={props.className}
      >
        {props.children}
      </div>
    </div>
  );
};
